import React from "react";
import styled from "@emotion/styled";

import { varColor } from "../../utils/themeHelpers";
import { Icon, IconName } from "../common/Icon";
import { typographyCoreStyles, typographyStyles } from "../common/Typography";

export const GroupHeading = styled.header(
    typographyCoreStyles,
    typographyStyles.label,
    {
        paddingInlineStart: `${24 / 16}rem`,
        paddingBlock: `${7 / 16}rem`,
        color: varColor("primary", "silver"),
    },
);

export const GroupList = styled.ol`
    margin: 0;
    padding: 0.0625rem 0.75rem;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
`;

export const GroupItem = styled.li`
    display: flex;
`;

export const renderIcon = (icon: IconName | null | undefined) =>
    icon ? <Icon size="18" name={icon} /> : null;

export const GroupChunk = styled.section`
    margin-bottom: 1rem;
`;

export const Groups = styled.section``;
